<template>
  <div class="toggle" :class="list.length < 4&& list.length != 1 ? 'flexWidth' : '' || list.length == 1&&list.length < 4 ? 'flexone' : ''" >
    <van-tabs v-model="active" :ellipsis="false" @click="onTabClicked">
      <van-tab v-for="(item, index) in list" :key="index">
        <template #title>
          <div class="party">
            <div class="avatars">
              <img :src="item.avatar" class="avatar" />
              <img
                src="http://img.wish.hebyun.com.cn/images/party.png"
                class="party_icon"
                v-if="item.type === 2"
              />
              <img
                src="http://img.wish.hebyun.com.cn/images/organ.png"
                class="party_icon"
                v-if="item.type === 3"
              />
            </div>
            <div class="party_right">
              <div class="name">{{ item.nick }}</div>
              <div class="time">{{ item.date }}</div>
            </div>
          </div>
        </template>
        <slot name="content"></slot>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
export default {
  props: ["list"],
  data() {
    return {
      active: 2,
      arr: [],
    };
  },
  methods: {
    onTabClicked(p) {
      this.$emit("partyClick", this.list[p]);
    },
  },
};
</script>

<style lang="scss" scoped>
.toggle {
  /deep/.van-tabs__nav {
    background-color: transparent;
    padding: 0;
  }
  /deep/.van-tabs__line {
    width: 0;
  }
  /deep/.van-tabs--line .van-tabs__wrap {
    height: auto;
    border-radius: 8px 8px 0 0 ;
  }
  /deep/.van-tab {
    padding: 0;
    justify-content: flex-start;

    .van-tab__text {
      width: 100%;
    }
  }
}
.van-tab {
  .party {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 93px;
    height: 40px;
    display: flex;
    align-items: center;
    border-radius: 10px 10px 0px 0px;
    border: solid 1PX #e4806f;
    border-left: 0;
    .avatars {
      position: relative;
      width: 26.5px;
      height: 27px;
      .avatar {
        width: 26.5px;
        height: 27px;
        border-radius: 50%;
      }
      .party_icon {
        position: absolute;
        top: -2px;
        right: -2px;
        width: 10px;
        height: 11px;
      }
    }
    .party_right {
      font-size: 11.5px;
      line-height: 1;
      color: #e50012;
      margin-left: 8px;
      .name {
        margin-bottom: 3px;
      }
    }
  }
}
.van-tab.van-tab--active {
  .party {
    border-bottom: none;
  }
}
.flexWidth {
  .van-tab {
    flex: 1;
    .van-tab__text {
      display: block;
      width: 100%;
      .party {
        width: calc(100% - 40px);
        padding: 0 20px;
        justify-content: center;
      }
    }
  }
}
.flexone {
  .van-tab {
    flex: 1;
    .van-tab__text {
      display: block;
      width: 100%;
      .party {
        width: calc(100% - 40px);
        padding: 0 20px;
        justify-content: flex-start;
      }
    }
  }
}
</style>
